import { Link } from 'react-router'

import { GENERATOR_SPEC_TYPE } from '~/portal/types/code.generator'
import { SHUBApiDetails } from '~/shared/types/api'

export const GenerateCodeLink = ({ lang, type, productId, path, orgName, SHUBApiDetails }: {
  lang: string,
  type: GENERATOR_SPEC_TYPE,
  productId?: string,
  path?: string,
  orgName?: string,
  SHUBApiDetails?: SHUBApiDetails
}) => {
  const searchParams = {
    lang,
    type,
    ...(productId ? { productId } : {}),
    ...(path ? { path } : {}),
    ...(orgName ? { orgName } : {}),
    ...(SHUBApiDetails?.orgName ? { owner: SHUBApiDetails.orgName } : {}),
    ...(SHUBApiDetails?.name ? { apiName: SHUBApiDetails.name } : {}),
    ...(SHUBApiDetails?.version ? { apiVersion: SHUBApiDetails.version } : {}),
  }
  
  return (
    <Link className="block w-full text-left px-4 py-1.5" key={lang}
      to={`/services/api/generatecode?${new URLSearchParams(searchParams).toString()}`} reloadDocument={true}>
      {lang}
    </Link>
  )
}